export default "__VITE_ASSET__7c5a17f9__"